import type { FC } from 'react';
import React from 'react';
import { useTracking, useTranslation } from '@edreamsodigeo/frontend-core';
import { Button } from '@edreamsodigeo/prisma-design-system';

import { useFlightSummaryActions } from '@/clientState/providers/FlightSummaryActionsProvider';
import { useShoppingSummaryItinerary } from '@/queries/useShoppingSummaryItinerary';
import useItineraryData from '@/clientState/hooks/useItineraryData';
import { TransportType } from '@/generated/graphql';

const MetaContinueButton: FC = () => {
  const { onContinueWithFlight } = useFlightSummaryActions();
  const { t } = useTranslation();
  const { trackEvent } = useTracking();
  const { data } = useShoppingSummaryItinerary();
  const { transportTypes, isMultiDestination, isRoundTrip } = useItineraryData(
    data?.products
  );

  const handleContinueWithFlight = (): void => {
    const hasTrain = transportTypes.includes(TransportType.Train);
    const hasFlight = transportTypes.includes(TransportType.Plane);
    const crossFaringOrTrainProductCode = hasFlight ? 'xfaring' : 'train';

    const productTrackingSection = !hasTrain
      ? 'flight'
      : crossFaringOrTrainProductCode;

    const roundTripOrOneWayCode = isRoundTrip ? 'RT' : 'OW';

    const tripTypeTrackingSection = isMultiDestination
      ? 'MD'
      : roundTripOrOneWayCode;

    // TODO: [TITANS-104] When mobile equal prominence is developed, we should add the selected option to the label
    const equalProminenceTrackingSection = '';
    trackEvent({
      action: 'continue_button',
      label: `p:${productTrackingSection}_type:${tripTypeTrackingSection}${equalProminenceTrackingSection}`,
    });
    onContinueWithFlight();
  };

  return (
    <Button type="primary" fullWidth={true} onClick={handleContinueWithFlight}>
      {t('flightSummary.continueButton')}
    </Button>
  );
};

export default MetaContinueButton;
